import allLocales from 'shared/constants/locales.js';

const toBcp47 = code => String(code).replace(/_/g, '-');

const displayNamesCache = new Map();

const displayNamesFor = locale => {
  if (!displayNamesCache.has(locale)) {
    displayNamesCache.set(
      locale,
      new Intl.DisplayNames([locale], { type: 'language' })
    );
  }
  return displayNamesCache.get(locale);
};

export const localeDisplayName = (code, uiLocale) => {
  const fallback = allLocales[code] || code;
  if (!code || !uiLocale) return fallback;
  try {
    const locale = toBcp47(uiLocale);
    const name = displayNamesFor(locale).of(toBcp47(code));
    if (!name || name === toBcp47(code)) return fallback;
    return name.charAt(0).toLocaleUpperCase(locale) + name.slice(1);
  } catch {
    return fallback;
  }
};
